import { Box } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

export const SmsLiveDot = styled(Box, { name: 'SmsLiveDot' })(({ theme }) => {
  const color = theme.palette.custom.OV.sys.success;

  return {
    width: '0.4rem',
    height: '0.4rem',
    borderRadius: '50%',
    backgroundColor: color,
    flexShrink: 0,
    animation: 'sms-live-pulse 2s ease-out infinite',
    '@keyframes sms-live-pulse': {
      '0%': { boxShadow: `0 0 0 0 ${alpha(color, 0.45)}` },
      '70%': { boxShadow: `0 0 0 0.375rem ${alpha(color, 0)}` },
      '100%': { boxShadow: `0 0 0 0 ${alpha(color, 0)}` },
    },
    '@media (prefers-reduced-motion: reduce)': {
      animation: 'none',
    },
  };
});
